import * as React from 'react';

export default class extends React.PureComponent {

    render(): React.Node {
        return <img src={require('../assets/img/logo.png')} alt="Sixmedia, s.r.o." className="logo" style={{height: '40px'}} />
    }
}